export default function useActionPaid (booking, paid, editBookingStationTime) {
  function toggleMarkAsPaid () {
    if (paid.value) {
      booking.value.bookingStationTimes.forEach(bookingStationTime => {
        editBookingStationTime(bookingStationTime._id, 'amountDue', bookingStationTime.amountDue + bookingStationTime.amountPaid);
        editBookingStationTime(bookingStationTime._id, 'amountPaid', 0);
      });
    } else {
      booking.value.bookingStationTimes.forEach(bookingStationTime => {
        editBookingStationTime(bookingStationTime._id, 'amountPaid', bookingStationTime.amountPaid + bookingStationTime.amountDue);
        editBookingStationTime(bookingStationTime._id, 'amountDue', 0);
      });
    }
  }

  return {
    toggleMarkAsPaid,
  };
}
